import { render, staticRenderFns } from "./SelectSearchMultipleUri.vue?vue&type=template&id=22a148d6&"
import script from "./SelectSearchMultipleUri.vue?vue&type=script&lang=js&"
export * from "./SelectSearchMultipleUri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports